import { BasePrescriptionTemplate } from './BasePrescriptionTemplate';
import type { PrescriptionPrintTemplateProps } from '../types';

const formatCardiologySummary = (specialtyData: Record<string, unknown> | null): string | null => {
  if (!specialtyData) return null;

  const hypertension = specialtyData.hypertension;
  if (!hypertension || typeof hypertension !== 'object') return null;

  const stageValue = (hypertension as { stage?: unknown }).stage;
  if (typeof stageValue !== 'string' || stageValue.trim() === '') return null;

  return `Contexto cardiovascular: HTA ${stageValue}.`;
};

export function CardiologyPrescriptionTemplate(props: PrescriptionPrintTemplateProps) {
  const cardiologySummary = formatCardiologySummary(props.specialtyData);

  if (!cardiologySummary) {
    return <BasePrescriptionTemplate {...props} />;
  }

  const mergedRecommendations = props.consultation.general_recommendations
    ? `${cardiologySummary}\n${props.consultation.general_recommendations}`
    : cardiologySummary;

  return (
    <BasePrescriptionTemplate
      {...props}
      consultation={{
        ...props.consultation,
        general_recommendations: mergedRecommendations,
      }}
    />
  );
}
